module.exports = __webpack_public_path__ + "img/지역사회_old.eae45adf.png";